import styled from 'styled-components';
import { Typography } from '@experian-uk/corvetteuk-common-ui';
import Button from '@nebula/button';

const { Headings } = Typography;

export const Heading = styled(Headings.Primary)`
  text-align: left;
  margin-bottom: ${props => props.theme.base.expSpacingSmall};
`;

export const CardFormContainer = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > form {
    flex: 0 0 100%;
    order: 1;

    ${({ theme }) =>
      theme.media(
        '15',
        `
      flex: 1 0 50%;
      order: 0;
    `
      )}
  }

  > section {
    flex: 0 0 100%;
    order: 0;
    padding: 1rem;

    ${({ theme }) =>
      theme.media(
        '15',
        `
      flex: 0 1 calc(50% - 1rem);
      order: 1;
    `
      )}
  }
`;

export const CardFormContainer3ds = styled(CardFormContainer)`
  margin-bottom: ${props => props.theme.base.expSpacingSmall};
  justify-content: end;

  > section {
    border: 1px solid ${props => props.theme.colors.baseMediumGrey};
  }
`;

export const IFrame = styled.iframe`
  border: none;
  display: block;
  margin: 0 auto;
  min-height: 70vh;
  overflow: scroll;
  width: 100%;

  @media (max-width: 1024px) {
    min-height: 95vh;
  }
`;

export const StyledButton = styled(Button)`
  span {
    font-size: 16px;
  }
`;

export const NewCardDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin: 0 0 40px auto;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: calc((100% - 48px) / 2);
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 400px);
`;
